import { Timestamp } from '@bufbuild/protobuf/wkt'

import { formatTimestamp } from '@/lib/date/date'

export const getAssessmentName = ({
  orgCompanyName,
  projectName,
  createdAt,
}: {
  orgCompanyName?: string
  projectName?: string
  createdAt?: Timestamp
}) => {
  const date = createdAt ? formatTimestamp(createdAt!, 'monthDay') : null

  return [orgCompanyName, projectName, date].filter(Boolean).join(' - ')
}
